import { useQuery, useMutation, useQueryClient } from 'react-query';
import { 
  uploadBatchAudios, 
  uploadBatchEbooks, 
  getUploadedAudios, 
  getUploadedEbooks,
  deleteAudio,
  deleteEbook
} from '../../api/admin/adminMultipleContents';
import useAuthStore from '../../store/authStore';

export const useMultipleContent = (contentType = 'audio') => {
  const queryClient = useQueryClient();
  const { user } = useAuthStore();
  const queryKey = contentType === 'ebook' ? 'admin-ebooks' : 'admin-audios';

  // Get uploaded content
  const { data, isLoading, error, refetch } = useQuery(
    [queryKey],
    () => contentType === 'ebook' ? getUploadedEbooks() : getUploadedAudios(),
    {
      enabled: !!user,
      onError: (error) => {
        console.error(`Failed to fetch ${contentType}s:`, error);
      }
    }
  );

  // Upload batch content mutation
  const uploadBatchMutation = useMutation(
    (formData) => contentType === 'ebook' ? uploadBatchEbooks(formData) : uploadBatchAudios(formData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKey);
      },
      onError: (error) => {
        console.error(`Failed to upload ${contentType}s:`, error);
      }
    }
  );

  // Delete content mutation
  const deleteContentMutation = useMutation(
    (id) => contentType === 'ebook' ? deleteEbook(id) : deleteAudio(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKey);
      },
      onError: (error) => {
        console.error(`Failed to delete ${contentType}:`, error);
      }
    }
  );

  return {
    content: data,
    isLoading,
    error: error?.response?.data?.message || error?.message,
    uploadBatch: uploadBatchMutation.mutate,
    isUploading: uploadBatchMutation.isLoading,
    uploadError: uploadBatchMutation.error?.response?.data?.message || uploadBatchMutation.error?.message,
    deleteContent: deleteContentMutation.mutate,
    isDeleting: deleteContentMutation.isLoading,
    deleteError: deleteContentMutation.error?.response?.data?.message || deleteContentMutation.error?.message,
    refetch
  };
};